export default "__VITE_ASSET__BoZNpQ6w__"